<script>
import TableList from "@/components/table-list/TableList.vue";
import {request} from "@/config/request";

export default {
  name: "SelectElPopup",
  components: {TableList},
  data() {
    return {
      tableData: [],
      selection: [],
      searchForm: {},
      showDialog: false,
    }
  },
  methods: {
    async handleSearch(params) {
      try {
        let res = await request(this.$api.elFlag.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
      } catch (e) {
        console.error(e);
      }
    },

    handleSelect() {
      this.$emit('select', this.selection);
      this.showDialog = false;
    },

    // 清空所选的
    handleClear() {
      this.$refs.list.clearSelection();
    }
  },
}
</script>

<template>
  <el-dialog :title="$t('选择元素')" width="800px" :close-on-click-modal="false"  :visible.sync="showDialog">
    <table-list
        :max-height="500"
        ref="list"
        @query="handleSearch"
        :request-params="{onPage: false}"
        :search-params="searchForm"
        :data="tableData"
        :on-page="false"
        :show-page="false"
        @selection-change="selection = $event">
      <el-table-column type="selection" width="50"/>
      <el-table-column prop="number" :label="$t('标识')"/>
      <el-table-column prop="name" :label="$t('对应营养元素')"/>
      <el-table-column prop="createTime" :label="$t('创建时间')">
        <template v-slot="{row}">
          {{ row.createTime | formatDate }}
        </template>
      </el-table-column>
    </table-list>
    <template #footer>
      <el-button @click="handleSelect" type="primary">{{ $t('选择元素') }}</el-button>
      <el-button @click="showDialog = false">{{ $t('关闭') }}</el-button>
    </template>
  </el-dialog>
</template>

<style scoped>

</style>
